import {http, api, store} from '@/libs'
import iView from 'iview'

// 默认
store.registerModule('main', {
  namespaced: true,
  state: {
    setupFrontPromise: null,
    setupFront: {baseShow: {}, enableMenu: {}, payment: {}},
    // // 页面主题缓存
    // frame: JSON.parse(localStorage.getItem('frame')) || { layout: true, theme: 'light' },
    // breadcrumb: {
    //   list: [],
    //   category: [],
    //   page: ''
    // },
    // config: { baseJson: { loginBgImg: [] } },
    // setUpFrontConfig: {},
    // setupFrontList: []
    // breadcrumb: {
    //   list: [],
    //   menuSubs: [],
    //   menuItem: ''
    // },
    // faceVerify: {},

    // 倒计时使用的数据
    countDown: {
      second: 60,
      text: '发送验证码',
      disable: false
    },
    interVals: [],

    // 文章数据
    article: {
      list: {content: []},
      info: {},
    },

    // vision
    breadcrumb: {
      list: [],
      category: [],
      page: ''
    },
    config: {baseJson: {title: ''}}
  },
  mutations: {
    HTTP_UPDATE_LOADING(state) {

    },

    // 倒计时使用的
    SET_COUNT_DOWN(state, second) {
      state.countDown.second = second
      state.countDown.text = second === 0 ? '再次发送' : '请稍等 ' + second
      state.countDown.disable = !!second
    },
    SET_CLEAR_INTERVAL(state) {
      state.interVals.forEach((item) => {
        clearInterval(item)
      })
      state.interVals = []
      state.countDown.second = 60
      state.countDown.text = '发送验证码'
    },
    SET_PUSH_INTERVAL(state, interVal) {
      state.interVals.push(interVal)
    },

    SET_FACE_VERIFY(state, payload) {
      state.faceVerify = payload
    },

    // 设置面包导航数据和菜单数据
    SET_BREADCRUMB_DATA(state, to) {
      state.breadcrumb.list = to.matched
      to.matched.map(item => {
        item.path.split('/').map(key => {
          if (key && state.breadcrumb.category.indexOf(key) === -1) {
            state.breadcrumb.category.push(key)
          }
        })
      })
      state.breadcrumb.page = to.path.replace('/center/', '')
    },
    // SET_BREADCRUMB_DATA(state, to) {
    //   state.breadcrumb.list = to.matched
    //   console.log(to)
    //   state.breadcrumb.menuItem = to.path.replace('/custom/', '')
    //   state.breadcrumb.menuSubs.push(state.breadcrumb.menuItem.substr(0, state.breadcrumb.menuItem.indexOf('/')))
    // },

    // 服务器数据库中对前端的配置JSON
    SET_CONFIG_DATA(state, payload) {
      state.config = payload
    },

    //
    // // 设置菜单样式和宽度
    // SET_FRAME_STORAGE_DATA(state, frame) {
    //   state.frame = frame
    //   localStorage.setItem('frame', JSON.stringify(frame))
    // },
    //
    // SET_CONFIG_DATA(state, payload) {
    //   state.config = payload
    // },
    // SET_UP_FRONT_CONFIG_DATA(state, payload) {
    //   state.setUpFrontConfig = payload
    // },
    // SET_SET_UP_FRONT(state, payload) {
    //   state.setupFrontList = payload
    // },
    SETUP_FRONT_PROMISE(state, promise) {
      state.setupFrontPromise = promise
    },
    SETUP_FRONT(state, payload) {
      Object.assign(state.setupFront, payload)
    },
    HTTP_POST_SUCCESS(state, message) {
      // iView.Message.success({
      //   content: message,
      //   duration: 1,
      //   closable: true
      // });
    },
    HTTP_POST_FAILED(state, message) {
      console.log("failed", message)
      iView.Message.error({
        content: message,
        duration: 10,
        closable: true
      });
    },

    // 文章
    SET_ARTICLE_DATA(state, payload) {
      payload.id ? state.article.info = payload : state.article.list = payload
    }
  },

  actions: {
    // 获取前端配置文件
    getSiteSetupFront(store) {
      return http.get(api.libBaseSaas.setupFront, {params: {dataKey: document.getElementById('customize').getAttribute('data-front-role')}}).then(payload => store.commit('SET_CONFIG_DATA', payload))
    },

    // 获取前端配置文件
    getSetupFront(store) {
      let httpPromise = http.get(api.libBaseSaas.setupFront, {params: {dataKey: api.frontRole}})
      store.commit('SETUP_FRONT_PROMISE', httpPromise)
      httpPromise.then(payload => store.commit('SETUP_FRONT', payload))
      return httpPromise
    },
    //
    // // 获取前端配置文件
    // getSiteSetUpFront(store) {
    //   return _http.get(_api.common.libSass.siteSetUpFront, { params: { dataKey: io_tubo_api.getAttribute('platform') } }).then(payload => store.commit('SET_CONFIG_DATA', payload))
    // },
    // // 获取前端配置文件-全部作为一个json
    // getSiteSetUpFrontAll(store) {
    //   return _http.get(_api.common.libSass.siteSetUpFrontAll).then(payload => store.commit('SET_UP_FRONT_CONFIG_DATA', payload))
    // },
    // //获取SaasSiteSetupFront配置信息列表
    // getSaasSiteSetupFront(store, param) {
    //   return _http.get(_api.sys.sys.getSaasSiteSetupFront).then(payload => store.commit('SET_SET_UP_FRONT', payload))
    // },
    // //设置SaasSiteSetupFront配置信息
    // setSaasSiteSetupFront(store, params) {
    //   return _http.post(_api.sys.sys.setSaasSiteSetupFront, params)
    // },
    // 上传图片，返回图片相对路径（在OSS中的路径）
    postThirdOss(store, params) {
      // return _http.post(_api.common.libThird.oss, params)
    },

    // 人脸识别
    postFaceVerify(store, param) {
      // return _http.post(_api.common.libThird.faceVerifyBase64, param).then(payload => store.commit('SET_FACE_VERIFY', payload))
    },

    // 人脸识别
    postFaceVerifyByUrl(store, param) {
      // return _http.post(_api.common.libThird.faceVerifyUrl, param).then(payload => store.commit('SET_FACE_VERIFY', payload))
    },

    // 发送验证码
    thirdSmsCodeSend(store, param) {
      return http.get(api.libThird.smsSend, {params: param}).then(() => {
        const _interVal = setInterval(() => {
          store.commit('SET_COUNT_DOWN', store.state.countDown.second - 1)
          if (store.state.countDown.second === 0) {
            clearInterval(_interVal)
            store.state.countDown.second = 60
          }
        }, 1000)
        store.commit('SET_PUSH_INTERVAL', _interVal)
      })
    },
    // 发送验证码（使用随机码）
    thirdSmsCodeSendKaptcha(store, param) {
      return http.get(api.libThird.smsSendKaptcha, {params: param}).then(() => {
        const _interVal = setInterval(() => {
          store.commit('SET_COUNT_DOWN', store.state.countDown.second - 1)
          if (store.state.countDown.second === 0) {
            clearInterval(_interVal)
            store.state.countDown.second = 60
          }
        }, 1000)
        store.commit('SET_PUSH_INTERVAL', _interVal)
      })
    },
    // 获取文章
    getArticleList(store, params) {
      return http.get(api.libClientInfo.article, {params}).then(payload => store.commit('SET_ARTICLE_DATA', payload))
    }
  }
})
